import React from 'react';

import PropTypes from 'prop-types';

import { getMetaNavLinks } from 'utils/AEMPropUtils';

import './PublicFooter.sass';

export const PublicFooter = ({ cqItems }) => {
  const metaNavLinks = getMetaNavLinks(cqItems.root[':items'].footer);

  return (
    <div className="public-footer">
      <div className="public-footer__border" />
      <div className="public-footer__container">
        {metaNavLinks.map((value, index) => (
          //
          // eslint-disable-next-line react/no-array-index-key
          <a key={index} href={value.url} className="public-footer__link">
            {value.linkTitle}
          </a>
        ))}
      </div>
    </div>
  );
};

PublicFooter.displayName = 'PublicFooter';

PublicFooter.propTypes = {
  cqItems: PropTypes.object,
};

PublicFooter.defaultProps = {
  cqItems: {},
};
